import React from 'react';
// ab-logo.png is the white variant — the blue mark reads on this light ground.
import logo from '../../assets/images/atadaboard-logo.png';
import './schoolProfile.css';

/**
 * Shared layout for the not-found and error pages. Same paper, rules and type
 * as a real profile, so a dead link still looks like part of the site rather
 * than a browser error.
 */
const SchoolProfileStateLayout = ({ code, title, message, children, footNote = null }) => (
  <main className="sp-state">
    <div className="sp-state-inner">
      <img src={logo} alt="AtadaBoard" className="sp-state-logo" />

      <div className="sp-state-body">
        {code && <p className="sp-label sp-state-code">{code}</p>}
        <h1 className="sp-display sp-display-m sp-state-title">{title}</h1>
        <p className="sp-standfirst sp-state-message">{message}</p>

        {children && <div className="sp-actions sp-state-actions">{children}</div>}
        {footNote && <p className="sp-state-note">{footNote}</p>}
      </div>
    </div>

    <style>{`
      .sp-state {
        min-height: 100dvh;
        display: flex;
        align-items: center;
        background: var(--sp-paper);
        color: var(--sp-ink);
        font-family: var(--sp-text);
        position: relative;
        padding: 3rem var(--sp-gutter);
        box-sizing: border-box;
      }

      .sp-state-inner {
        width: 100%;
        max-width: 1240px;
        margin: 0 auto;
      }

      .sp-state-logo {
        display: block;
        height: 26px;
        width: auto;
      }

      .sp-state-body {
        margin-top: clamp(3rem, 12vh, 7rem);
        max-width: 34rem;
        padding-top: 2rem;
        border-top: 1px solid var(--sp-rule);
      }

      .sp-state-code {
        margin-bottom: 1rem;
      }

      .sp-state-message {
        margin-top: 1rem;
      }

      .sp-state-actions {
        margin-top: 2.25rem;
      }

      .sp-state-note {
        margin: 2rem 0 0 0;
        max-width: 44ch;
        font-size: 0.9rem;
        line-height: 1.6;
        color: var(--sp-ink-muted);
      }
    `}</style>
  </main>
);

export default SchoolProfileStateLayout;
